export default [
    {
        path: "/user",
        name: "user",
        component: () => import("@/views/user/User.vue"),
        meta: {
            pageTitle: "List User",
            breadcrumb: [
                {
                    text: "List User",
                    active: true
                }
            ],
            middleware: "Auth"
        }
    },
];
